

export class UserAttributeDocument {
    public name: string = '';
    public description: string = '';
    public documentType: string = '';
    public documentExtType: string = '';
    public dispositionType: string = '';
    public reference: string = '';
    public fileGUID: string = '';
    public data: any;
}
